










import { Component, Vue } from 'vue-property-decorator';
import DefaultSignupComplete from '@/components/organisms/default/signup/DefaultSignupComplete.vue';
import PRS0000001SignupComplete from '@/components/organisms/PRS0000001/signup/PRS0000001SignupComplete.vue';
import { AllowSettings } from '@/types/converter/convert';
import { VueHelper } from '@/helpers/vue';
import PRS0000001SubFooter from '@/components/organisms/PRS0000001/footer/PRS0000001SubFooter.vue';

@Component({
    components: {
        DefaultSignupComplete,
        PRS0000001SignupComplete,
        PRS0000001SubFooter
    },
})
export default class SignupComplete extends Vue {

    private provisionShopCode: string = "";

    mounted () {
        this.provisionShopCode = VueHelper.getParameter(this, 'provision_shop_code')

        if (!AllowSettings.isUseSignup(this.provisionShopCode)) {
            VueHelper.move(this, '/404')
        }
    }

}
